var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middle-box text-center loginscreen"},[_c('div',[_c('div',[_vm._v("Git Describe: "+_vm._s(_vm.gitVersion))]),_c('div',[_vm._v("Git Branch Name: "+_vm._s(_vm.branckName))]),_c('div',[_vm._v("Build Date: "+_vm._s(_vm.buildDate))]),_c('div',[_vm._v("Version Number:"+_vm._s(_vm.version))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }